import React from 'react';
// import { OrderItem } from '../../types';
import { useSelectedArticleStore } from '../../../../store/store';
import { OutboundOrderItem } from '../../../../api/warehouse/generated/src';
import { BsPlus } from 'react-icons/bs';

interface PickListItemProps {
    item: OutboundOrderItem;
    remainingQty: number;
    isExpanded: boolean;
    isLocationExpanded: boolean;
    itemRef: (el: HTMLDivElement | null) => void;
    onItemClick: (item: OutboundOrderItem) => void;
    onToggleExpanded: (itemId: string, e: React.MouseEvent) => void;
    onToggleLocationExpanded: (itemId: string, e: React.MouseEvent) => void;
    onOpenBatchModal: (item: OutboundOrderItem) => void;
    onOpenSerialModal: (item: OutboundOrderItem) => void;
    onOpenQtyModal: (item: OutboundOrderItem, e: React.MouseEvent) => void;
    onConfirmStandardPick: (item: OutboundOrderItem) => void;
    onOpenBatchQtyEdit: (item: OutboundOrderItem, batchIndex: number, e: React.MouseEvent) => void;
}

export const PickListItem: React.FC<PickListItemProps> = ({
    item,
    remainingQty,
    isExpanded,
    isLocationExpanded,
    itemRef,
    onItemClick,
    onToggleExpanded,
    onToggleLocationExpanded,
    onOpenBatchModal,
    onOpenSerialModal,
    onOpenQtyModal,
    onConfirmStandardPick,
    onOpenBatchQtyEdit,
}) => {
    const hasDetails = (item.type === 'batch' && item.selectedBatches && item.selectedBatches.length > 0) ||
        (item.type === 'serial' && item.serialNumbers && item.serialNumbers.length > 0) ||
        (item.type === 'standard' && item.pickedQty > 0);


    const selectedArticle = useSelectedArticleStore(state => state.article);

    const activeElement = item.id === selectedArticle.id;

    return (
        <div
            ref={itemRef}
            onClick={() => onItemClick(item)}
            className={`bg-white rounded-lg shadow-md transition-all cursor-pointer hover:shadow-xl ${activeElement ? 'ring-4 ring-yellow-400 shadow-2xl' : ''
                } ${item.status === 'completed' ? 'opacity-75' : ''
                }`}
        >
            <div className="flex">
                <div className="flex-1 p-4">
                    <div className="flex flex-row gap-4 justify-between">
                        <div className='flex flex-col xs:flex-row gap-2'>

                            <div className="relative">
                                <div className="flex flex-row xs:flex-col gap-2">
                                    <div className="bg-gray-200 text-black px-2 md:px-3 py-2 rounded-lg text-center w-[100px] md:w-[120px] flex-shrink-0 h-[50px] flex flex-col justify-center">
                                        <div className="text-lg md:text-xl font-bold">{item.location}</div>
                                        {/* {item.storageLocations && item.storageLocations.length > 1 && (
                                            <button
                                                onClick={(e) => onToggleLocationExpanded(item.id, e)}
                                                className="mt-1 bg-gray-600 hover:bg-gray-700 text-white text-[10px] md:text-xs px-2 py-0.5 rounded-full transition"
                                            >
                                                +{item.storageLocations.length - 1}
                                            </button>
                                        )} */}
                                    </div>

                                    {item.type === 'standard' ?
                                        <div
                                            onClick={(e) => onOpenQtyModal(item, e)}
                                            className={`text-white px-2 md:px-3 py-2 rounded-lg text-center w-[100px] md:w-[120px] flex-shrink-0 h-[50px] flex items-center justify-center cursor-pointer transition ${item.pickedQty === remainingQty
                                                    ? 'bg-green-500 hover:bg-green-600'
                                                    : item.pickedQty === 0
                                                        ? 'bg-gray-300 hover:bg-gray-400'
                                                        : 'bg-orange-400 hover:bg-orange-500'
                                                }`}
                                        >
                                            <div className="text-lg md:text-xl font-bold">{item.pickedQty}/{remainingQty}</div>
                                        </div>
                                        :    
                                        <div
                                            // onClick={(e) => onOpenQtyModal(item, e)}
                                            className={`text-white px-2 md:px-3 py-2 rounded-lg text-center w-[100px] md:w-[120px] flex-shrink-0 h-[50px] flex items-center justify-center transition ${item.pickedQty === remainingQty
                                                    ? 'bg-green-500'
                                                    : item.pickedQty === 0
                                                        ? 'bg-gray-300'
                                                        : 'bg-orange-400'
                                                }`}
                                        >
                                            <div className="text-lg md:text-xl font-bold">{item.pickedQty}/{remainingQty}</div>
                                        </div>
                                    }
                                </div>

                                {isLocationExpanded && item.storageLocations && item.storageLocations.length > 1 && (
                                    <div className="absolute top-0 left-full ml-2 bg-white border-2 border-gray-800 rounded-lg shadow-lg z-30 w-[240px]">
                                        <div className="p-3">
                                            <p className="text-xs font-semibold text-gray-600 mb-2">VERFÜGBARE LAGERPLÄTZE</p>
                                            {item.storageLocations.map((loc, idx) => (
                                                <div
                                                    key={idx}
                                                    className={`p-2 rounded mb-1 ${loc.isPrimary ? 'bg-blue-50 border border-blue-300' : 'bg-gray-50'}`}
                                                >
                                                    <div className="flex justify-between items-start">
                                                        <div>
                                                            <p className="font-bold text-sm">
                                                                {loc.location}
                                                                {loc.isPrimary && (
                                                                    <span className="ml-1 text-xs bg-blue-600 text-white px-1 rounded">HAUPT</span>
                                                                )}
                                                            </p>
                                                            <p className="text-xs text-gray-600">Verfügbar: {loc.quantity} Stk</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            {item.storageLocations && (
                                                <div className="mt-2 pt-2 border-t text-xs text-gray-600">
                                                    Gesamt verfügbar: {item.storageLocations.reduce((sum, loc) => sum + loc.quantity, 0)} Stück
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="flex-1 min-w-0 min-w-[100px]">
                                <div className="mb-2">
                                    <h3 className="font-bold text-base md:text-lg">{item.articleNumber}</h3>
                                    <p className="text-gray-700 text-sm md:text-base">{item.description}</p>
                                </div>

                                <div className="flex items-center gap-2">
                                    {hasDetails && item.type !== "standard" && (
                                        <button
                                            onClick={(e) => onToggleExpanded(item.id, e)}
                                            className={`px-2 py-1 rounded text-[10px] md:text-xs font-semibold cursor-pointer hover:opacity-80 transition ${item.type === 'serial' ? 'bg-purple-100 text-purple-800' :
                                                    item.type === 'batch' ? 'bg-blue-100 text-blue-800' :
                                                        'bg-gray-100 text-gray-800'
                                                }`}
                                        >
                                            {item.type === 'serial' ? 'Seriennummer' :
                                                item.type === 'batch' ? 'Chargenpflichtig' : 'Standard'} {isExpanded ? '▼' : '▶'}
                                        </button>
                                    )}
                                    {!hasDetails && item.type !== "standard" && (
                                        <span className={`px-2 py-1 rounded text-[10px] md:text-xs font-semibold ${item.type === 'serial' ? 'bg-purple-100 text-purple-800' :
                                                item.type === 'batch' ? 'bg-blue-100 text-blue-800' :
                                                    'bg-gray-100 text-gray-800'
                                            }`}>
                                            {item.type === 'serial' ? 'Seriennummer' :
                                                item.type === 'batch' ? 'Chargenpflichtig' : 'Standard'}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col gap-2 flex-shrink-0">
                            {item.imageUrl?.trim().length > 0 &&
                                <img
                                    src={item.imageUrl}
                                    alt={item.description}
                                    className="w-16 h-16 md:w-24 md:h-24 object-cover rounded-lg"
                                />
                            } 

                            {item.type === 'standard' && (
                                <button
                                    onClick={(e) => {
                                        // e.stopPropagation();
                                        onConfirmStandardPick(item);
                                    }}
                                    className={`w-16 h-16 md:w-24 md:h-24 text-white rounded-lg font-bold transition flex items-center justify-center text-4xl md:text-5xl ${activeElement
                                            ? 'bg-blue-600 hover:bg-blue-700'
                                            : 'bg-gray-300 hover:bg-gray-400'
                                        }`}
                                >
                                    <BsPlus />
                                </button>
                            )}

                            {item.type === 'batch' && (
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onOpenBatchModal(item);
                                    }}
                                    className={`w-16 h-16 md:w-24 md:h-24 text-white rounded-lg font-bold transition flex items-center justify-center text-4xl md:text-5xl ${activeElement
                                            ? 'bg-blue-600 hover:bg-blue-700'
                                            : 'bg-gray-300 hover:bg-gray-400'
                                        }`}
                                >
                                    <BsPlus />
                                </button>
                            )}

                            {item.type === 'serial' && (
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onOpenSerialModal(item);
                                    }}
                                    className={`w-16 h-16 md:w-24 md:h-24 text-white rounded-lg font-bold transition flex items-center justify-center text-4xl md:text-5xl ${activeElement
                                            ? 'bg-blue-600 hover:bg-blue-700'
                                            : 'bg-gray-300 hover:bg-gray-400'
                                        }`}
                                >
                                    <BsPlus />
                                </button>
                            )}
                        </div>
                    </div>

                    {hasDetails && isExpanded && (
                        <div className="mt-4 pt-4 border-t border-gray-200">
                            {item.type === 'batch' && item.selectedBatches && item.selectedBatches.length > 0 && (
                                <div>
                                    <p className="font-semibold mb-2 text-sm text-blue-800">Erfasste Chargen:</p>
                                    <div className="space-y-2">
                                        {item.selectedBatches.map((sb, idx) => (
                                            <div key={'b_' + idx} className="bg-blue-50 p-2 rounded border border-blue-200 flex items-center justify-between">
                                                <div
                                                    onClick={(e) => onOpenBatchQtyEdit(item, idx, e)}
                                                    className="bg-blue-600 text-white px-2 py-1 rounded text-center w-[80px] cursor-pointer hover:bg-blue-700 transition mr-3"
                                                >
                                                    <div className="text-xs font-semibold">MENGE</div>
                                                    <div className="text-base font-bold">{sb.quantity}</div>
                                                </div>
                                                <div className="flex-1">
                                                    <p className="font-bold text-sm">{sb.batch.batchNumber}</p>
                                                    <p className="text-xs text-gray-600">MHD: {new Date(sb.batch.expiryDate).toLocaleDateString('de-DE')}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {item.type === 'serial' && item.serialNumbers && item.serialNumbers.length > 0 && (
                                <div>
                                    <p className="font-semibold mb-2 text-purple-800">Erfasste Seriennummern:</p>
                                    <div className=" flex flex-wrap gap-2">
                                        {item.serialNumbers.map(sn => (
                                            <div key={sn.number} className="bg-purple-50 p-2 rounded border border-purple-200">
                                                <p className="text-sm">• {sn.number}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* {item.type === 'standard' && item.pickedQty > 0 && (
                                <div>
                                    <p className="font-semibold text-gray-800">Details zur Entnahme</p>
                                </div>
                            )} */}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};